import React, {useContext, useEffect, useMemo} from 'react'
import headbandContext from 'contexts/headband'
import Iframe from 'components/iframe/iframe'
export default function Actus() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title : "L'actu de la semaine",
            icon : "picto_actu.svg",
            color : "bckDarkBlue"
        })
    }, [])
    return(
    
        <div id="actus" className='page'>
            <Iframe url="https://docs.google.com/presentation/d/e/2PACX-1vS2EfSEvqLc82dWMSotwdC873_MbHR0ahaE_k0Wi52ZPAT8-mHPCwjC_BtrQ-ID847NMoj2JpNed6hj/embed?start=true&loop=false&delayms=3000"/>
        </div>
    )
}